import React from "react";
import { Button } from "react-bootstrap";
import styled from "styled-components";
import useLanguage from "../../../../utilities/useLanguage";
import { getTranslation } from "../../translations";

const ApplyContainer = styled.div`
    @media(min-width:992px) and (max-width:1199px){
        a{
            .macu-btn{
                width:100% !important;
            }
        }
    }
    
    @media(max-width:576px) {
        a {
            .macu-btn {
                width: 100% !important;
            }
        }
    }
`;
export default (props) => {
    const { disabled, employeeUrl, referrerId } = props;
    const { lang } = useLanguage();

    let href = "https://secure.macu.com/#/sso-start?loanType=MORTGAGE";

    if (referrerId) {
        href = href + '&referrerId=' + encodeURIComponent(referrerId);
    }

    if (employeeUrl) {
        href = employeeUrl;
    }

    return (
        <ApplyContainer className="col-lg-4 col-md-6 col-12 px-1 pt-3 pb-0 text-center">
            <a href={href}>
                <Button disabled={disabled} className="macu-btn small inverse mb-3 w-75 mrqt-apply-button py-2">{getTranslation(lang).applyLoanOnline}</Button>
            </a>
            <br />
            <a className="text-dark" href="https://www.macu.com/loans/home-loans/meet-with-a-mortgage-loan-officer">{getTranslation(lang).meetWithMortgageExpert}</a>
        </ApplyContainer>
    );
};